import '../../styles/pages/blog/blog.scss'

import blog from '@/pages/blog/main'

const components = {
  blog,
}

app.add(components)
if (app?.getState()?.cart) app.mount()
